import { PrinterIcon } from '@heroicons/react/24/outline'
import { Button } from '@nextui-org/react'
import CancelOrderButton from '@scripts/frontend/features/shop/order/components/CancelOrderButton'
import { OrderStatusEnum } from '@scripts/frontend/features/shop/order/libs/type'
import { useOrder } from '@scripts/frontend/features/shop/order/libs/useOrder'
import { OrderHistoryDetail as OrderDetail } from '@scripts/frontend/features/shop/order/OrderHistoryDetail'
import OrderHistoryDetailLoader from '@scripts/frontend/features/shop/order/OrderHistoryDetailLoader'
import ErrorBoundary from '@shared/ErrorBoundary'
import { __ } from '@wordpress/i18n'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { orderId } = useParams<{ orderId: string }>()

  const { data: order, error, isLoading } = useOrder().getOrderById(orderId!)

  if (isLoading) return <OrderHistoryDetailLoader />

  if (error) {
    toast.error(error?.message || 'Failed to fetch order detail')
    showBoundary(error)
  }

  if (!orderId) {
    toast.error(__('Order not found', 'asavagroup'))
    showBoundary('Order not found')
    return <></>
  }

  return (
    <div>
      {order?.status === OrderStatusEnum.COMPLETED && (
        <div className="mb-4 flex justify-end space-x-2">
          <Button
            as={`a`}
            href={order?.invoicePermalink}
            startContent={<PrinterIcon className="h-5 w-5" />}
            target="_blank"
            variant="ghost"
          >
            View Invoice
          </Button>
        </div>
      )}
      {order && <OrderDetail order={order} />}
      {order?.status === OrderStatusEnum.PENDING && (
        <div className="mt-4 flex justify-end space-x-2">
          <CancelOrderButton orderId={orderId} />
          <Button
            as={`a`}
            color="primary"
            href={order?.paymentPermalink}
            variant="solid"
          >
            Pay
          </Button>
        </div>
      )}
    </div>
  )
}

export function OrderHistoryDetail() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default OrderHistoryDetail
